import React, { Component, useEffect, useState, Suspense} from "react";
import "./CreateVote.css";
import strings from "../../locales/ro.json"
import { UserAuth } from "../../context/AuthContext";
import requestHandler from "../../utils/requestHandler";
import CreateVoteTemplate from "../../components/Voting/CreateVoteTemplate/CreateVoteTemplate";
import HeaderElement from "../../components/HeaderElement/HeaderElement";
import backIcon from "../../assets/icons/back.svg";
import CreateVoteCard from "../../components/Voting/CreateVoteCard/CreateVoteCard";
import PillButton from "../../components/Buttons/PillButton/PillButton";
import { Margin } from "@mui/icons-material";
import StandardPopup from "../../components/Global/StandardPopup/StandardPopup";
import popupicon from "../../assets/icons/createVotPopup.svg";


const CreateVote = () => {
  const {templateTitle, questionTitlePlaceholder, abstainText} = strings.createVote;
  const { user } = UserAuth();
  const [templateChosen, setTemplateChosen] = useState(false);
  const [options, setOptions] = useState({});
  const myAuthToken =
    `Bearer ${user.accessToken}`;

  // send vote to backend and refresh page
  const ballotData = async () => {
    try {
      // options.options.push(abstainText) // This is so that we have abstain default.

      let result = await requestHandler("ballot","PUT",myAuthToken,{...options});
      
      window.location.reload(false)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const setTemplate = (template) => {
    setTemplateChosen(true);
    setOptions({...template, group: template.isGAV? "GAV" : undefined});

  };
  return templateChosen ? (
    <div className="create-vote-top">
      <div className='create-vote-back-button' onClick={() => {
        setTemplateChosen(false);
        setOptions({});
      }}>
        <img src={backIcon} alt="back" />
      </div>
      
      {/* <div className="create-vote-container">
        <HeaderElement placeholder={questionTitlePlaceholder} headerText={options?.title ? options.title : ""} inputHandler={setOptions}/>
      </div> */}
      <CreateVoteCard className='create-vote-container' options={options} handleOptions={setOptions}/>
    </div>
  ) : (
    <div className="create-vote-top">
      <HeaderElement headerText={templateTitle} />
      <div className="create-vote-template-container">
        {strings.createVote.templates.map((template, index) => {
          return (<CreateVoteTemplate
            title={template.title}
            icon={template.icon}
            template={template.template}
            setTemplate={setTemplate}
            key={index}
          />);
        })}
      </div>
    </div>
  );
};

export default CreateVote;
